export const MODAL_TYPES = {
  LOGIN: 'Login',
  SIGNUP: 'Signup',
  MERGE_MODAL: 'MergeModal',
  RESET_PASSWORD: 'ResetPassword',
  USER_PROFILE: 'UserProfile',
  USER_EDIT_PROFILE: 'EditProfile',
  MODAL_CONFIRM: 'ModalConfirm',
}

export const MODAL_NAME = {
  NOTIFICATION_WARNING: 'NOTIFICATION_WARNING',
  NOTIFICATION_ERROR: 'NOTIFICATION_ERROR',
}
